import React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import classNames from 'classnames';

import editorStoreConnect from '../../../../components/editor/store/components/editorStoreConnect';

// Actions
import { deselectAllElements, finishEditingCurrentElement } from '../../../../element/selection/selectionActions';
import { collapseTextEditorRange } from './toolbarDismissButtonActions';

// Components
import Icon from '../../../../components/icons/Icon';
import Button from '../../../../components/buttons/Button';

// Types
import { ToolbarList, ToolbarListType } from '../../toolbarTypes';

// Styles
import './ToolbarDismissButton.scss';

const mapDispatchToProps = (dispatch: Function) => ({
    deselectAll: () => dispatch(deselectAllElements()),
    finishEditing: () => dispatch(finishEditingCurrentElement()),
});

const mapEditorDispatchToProps = (dispatch: Function) => ({
    collapseSelectionRange: () => dispatch(collapseTextEditorRange()),
});

const connector = connect(null, mapDispatchToProps);
const editorStoreConnector = editorStoreConnect(undefined, mapEditorDispatchToProps);

type ToolbarDismissToolProps = ConnectedProps<typeof connector> & {
    show: boolean;
    activeToolbar?: ToolbarList;
    collapseSelectionRange?: () => boolean;
};

const ToolbarDismissTool = ({
    show,
    activeToolbar,
    deselectAll,
    finishEditing,
    collapseSelectionRange,
}: ToolbarDismissToolProps): React.ReactElement => {
    const handleClick = () => {
        if (!activeToolbar) return deselectAll();

        switch (activeToolbar.type) {
            case ToolbarListType.EDITING_RANGE: {
                const collapsed = collapseSelectionRange?.() || false;
                if (collapsed) return;

                return finishEditing();
            }
            case ToolbarListType.EDITING:
                return finishEditing();
            case ToolbarListType.SELECTED:
            default:
                return deselectAll();
        }
    };

    return (
        <div
            className={classNames('ToolbarDismissTool', {
                show,
            })}
        >
            <Button onClick={handleClick}>
                <Icon name="toolbar-dismiss" />
            </Button>
        </div>
    );
};

export default connector(editorStoreConnector(ToolbarDismissTool));
